import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from '../../../../services/mysql.service';

// 
import { Job } from '../../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule, NgForm } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map, of} from 'rxjs';
// 
import { Subscription } from 'rxjs';
// import { ErrorObservable } from 'rxjs';
// 

import { FileUploaderService } from '../../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from '../../../../services/global-functions.service';
import { JobReportSubject } from '../../../../shared/models/jobReportSubject.model';
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeAffidavit } from 'src/app/shared/models/jobTypeAffidavit.model';
import { SubjectCommunication } from 'src/app/shared/models/subjectCommunication.model';


@Component({
  selector: 'app-create-affidavit-widget',
  templateUrl: './create-affidavit-widget.component.html',
  styleUrls: ['./create-affidavit-widget.component.scss']
})
export class CreateAffidavitWidgetComponent implements OnInit {

   // setup as observable?
   @Input() item_id?; // impliments on changes.
   @Input() item_data?; // if data.model is sent : Observable<any[]>;
   @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
   @Input() item_user_level_id? = '5'; // default to agent just in case
   @Input() item_brand_type_id? = '';
   @Input() show_buttons? = 'no'; // yes | no
   @Input() widget_title? = '';
   @Input() widget_size? = 'side'; // side | abstract | full
  
  
   job_id: any;
  // job_type_id: any;
    // access the template form
    @ViewChild('traceForm') traceForm: NgForm;




    @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  

// for report tools
@Input() job_type_name?;
@Input() job_type_id?;
@Input() job_type_location_name?;
@Input() job_type_location_id?;
@Input() job_type_court_name?;
@Input() job_type_court_id?;
@Input() job_type_document_type_name?;
@Input() job_type_document_type_id?;
  job_types: any;
  model: any;
  get_latest_affidavit_id: any;
  job_type_locations: any;
  count2: any;
  job_type_courts: any;
  sent_job_type_location_id: number;
  job_type_document_types: any;
  sent_job_type_court_id: number;


  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef,
    public gfunc: GlobalFunctionsService
  ) { }


  // check for changes. to load data.
  ngOnChanges(changes) {
    if (changes.item_id) {
      // deal with asynchronous Observable result
      this.job_type_id = changes.item_id.currentValue;
     // test to see if loads undefined better.
     // this.job_id = this.item_id;

      // this.getJob(this.job_id);
      this.toastr.success('Presets Loaded' , this.job_type_id);
  


     // stops error on subjects page not having a job id initally
     if(this.job_type_id >= 1){

      this.model = new JobTypeAffidavit();
      // this.model = new SubjectCommunication(); //SubjectTemplateDocs

      this.model.job_type_id = this.job_type_id;
      this.model.job_type_location_id = this.job_type_location_id;
      this.model.job_type_court_id = this.job_type_court_id;
      this.model.job_type_document_type_id = this.job_type_document_type_id as number; // for some reason no double quotes in json as it was converted to string somewhere olong the line

 

      setTimeout(() => {  
        console.log("A Simple Pause!"); 
        this.getJobTypeDocumentTypes(this.job_type_court_id); 
        this.getJobTypes();
        this.getJobTypeLocations(this.job_type_id);
        this.getJobTypeCourts(this.job_type_location_id);
        console.log("Now Ready to load...");
      }, 900);

     }

      // :: Not needed to load for side 
      if (this.widget_size != 'side'){
      // this.getJobPlaintiffs(this.job_id); 
      // this.getJobReportSubjects(this.job_id);
      // this.getJobSubjectDocumentsByJobID(this.job_id);
      }

    }
  }

  ngOnInit(): void {
    // set here becase was not loading the default document?
    // this.model.job_type_document_type_id = "this.job_type_document_type_id";

        
  }


  createJobTypeAffidavit(model) {
    // console.log(model);
        this._demoService.createJobTypeAffidavit(model).subscribe(
             data => {  this.get_latest_affidavit_id = data; // this is the retuned json upon creation.
             this.toastr.success('Created');
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */
             this.closeParentModel.emit();
           //   CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Affidavit Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
             }
        );
        }



  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
    this.model.job_type_location_id = 1;
    this.model.job_type_court_id = 0;
    // this.model.job_type_document_type_id = 0;
    // this.model.job_type_affidavit_type_id = 0;

  }

  
  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
       data => { this.job_type_courts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
  
  }


  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
       data => { this.job_type_document_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....

  }

  

}
